import React from 'react';
import { Pagination as AntdPagination } from 'antd';
import { useTranslation } from 'react-i18next';

import 'antd/dist/antd.css';

import style from './Pagination.module.scss';

// showTotal = {(total, range) => `${range[0]}-${range[1]} of ${total} items`}

export const Pagination = ({ id, total, onChange, current, pageSize,
  showSizeChanger, showTotal, showQuickJumper, simple, size = 'large', onShowSizeChange }) => {

  const [ t ] = useTranslation();

  if (!showTotal) {
    showTotal = itemsTotal => `${t('totalItems')} ${itemsTotal} `;
  }

  const pageSizeOptions = [ '10', '25', '50', '100' ];

  return (
    <AntdPagination
      data-testid={ id }
      defaultCurrent={ 1 }
      current={ current }
      total={ total }
      defaultPageSize={ 10 }
      pageSize={ pageSize }
      onChange={ onChange }
      showSizeChanger={ showSizeChanger && total }
      onShowSizeChange={ (_, _pageSize) => {
        if (onShowSizeChange) {
          const _numberOfRecords = current * pageSize > total ? total : current * pageSize;
          onShowSizeChange(Math.ceil((_numberOfRecords) / _pageSize), _pageSize);
        }
      } }
      pageSizeOptions={ pageSizeOptions }
      showTotal={ showTotal }
      showQuickJumper={ showQuickJumper }
      size={ size }
      simple={ simple }
      style={ style }
    />
  );
};
